export enum Reserve {
    CancellationDaysDefault = 3,
    ReservableMonthsDefault = 3,
}
